import { useState } from "react";
import { Box, Button, Card, Tab, Tabs } from "@mui/material";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import "./blockchain-admin-ui.css";

export default function BlockchainAdminActions({ onRoundHistory, onBetHistory, onConfig, onRefresh, refreshing = false, configLabel = "Cấu hình", onGuide }) {
    const [value, setValue] = useState(0);
    const items = [
        onConfig && { label: "Tỉ lệ", icon: <SettingsRoundedIcon />, action: onConfig },
        onRoundHistory && { label: "Lịch sử phiên", icon: <HistoryRoundedIcon />, action: onRoundHistory },
        onBetHistory && { label: "Lịch sử đặt cược", icon: <ReceiptLongRoundedIcon />, action: onBetHistory },
        onRefresh && { label: refreshing ? "Đang tải..." : "Làm mới", icon: <RefreshRoundedIcon />, action: onRefresh, disabled: refreshing }
    ].filter(Boolean);

    return <Card className="blockchain-action-tabs" elevation={0} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1.5 }}>
        <Box className="blockchain-action-tabs__scroll" sx={{ flexGrow: 1, minWidth: 0 }}>
            <Tabs value={value} onChange={(_, next) => setValue(next)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Điều hướng quản lý game Blockchain">
                {items.map((item) => <Tab key={item.label} disabled={item.disabled} onClick={item.action} icon={item.icon} iconPosition="start" label={item.label} />)}
            </Tabs>
        </Box>
        {onGuide && (
            <Button
                size="small"
                onClick={onGuide}
                sx={{
                    ml: 1.5,
                    px: 1.5,
                    py: 0.5,
                    height: "32px",
                    color: "rgba(0, 0, 0, .88)",
                    border: "1px dashed #d9d9d9",
                    borderRadius: "8px",
                    fontSize: "13.5px",
                    fontWeight: 600,
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    bgcolor: "#ffffff",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                    flexShrink: 0,
                    "&:hover": { bgcolor: "#f8fafc", borderColor: "#2563eb", color: "#2563eb" }
                }}
            >
                Hướng dẫn <Box component="span" sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 15, height: 15, ml: 0.8, color: "#555", border: "1.5px solid #555", borderRadius: "50%", fontSize: 10, fontWeight: 700, lineHeight: 1 }}>?</Box>
            </Button>
        )}
    </Card>;
}
